import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormikContext } from 'formik';
import lodashGet from 'lodash/get';
import { memo, useCallback } from 'react';
import Input from '../Input';
const styles = {
    row: {
        display: 'flex',
        margin: '5px 0px',
        alignItems: 'center',
    },
    inputLabel: {
        flex: 2,
        fontSize: '11px',
        fontWeight: 'bold',
        color: '#232323',
    },
    input: {
        width: '60%',
        textAlign: 'center',
    },
};
function FormikColumnFormatField(props) {
    const { label, checkControllerName, formatControllerName, disableFormat = false, hideFormatField = false, hideCheckField = false, } = props;
    const { values, handleChange, setFieldValue } = useFormikContext();
    const changeHandler = useCallback((e) => {
        handleChange(e);
    }, [handleChange]);
    const checkChangeHandler = useCallback((e) => {
        setFieldValue(e.target.name, e.target.checked);
    }, [setFieldValue]);
    return (_jsxs("div", { style: styles.row, children: [_jsx("span", { style: styles.inputLabel, children: label }), _jsxs("div", { style: {
                    flex: 4,
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                }, children: [!hideCheckField && checkControllerName && (_jsx("input", { type: "checkbox", style: { margin: '0px 5px' }, name: checkControllerName, onChange: checkChangeHandler, checked: lodashGet(values, checkControllerName, false) })), !hideFormatField && formatControllerName && (_jsx(Input, { style: { inputWrapper: styles.input }, name: formatControllerName, value: lodashGet(values, formatControllerName, ''), onChange: changeHandler, type: "text", disabled: disableFormat }))] })] }));
}
export default memo(FormikColumnFormatField);
